
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Products } from "@components/products";
import { NextSeo } from "@components/seo";
import type { IProduct } from "@type/products";
import { getAllPvcProductsWithouParent } from "@utils/get-products";
import type { GetStaticProps, NextPage } from "next/types";
import { Breadcrumb } from "../../components/breadcrumb";
interface IPvcProducts {
    products: IProduct[];
}
const PvcProducts: NextPage<IPvcProducts> = ({ products }) => (<>
    <NextSeo languageAlternates={[
        { href: "https://knsokna.pl/pvc", hrefLang: "x-default" },
        { href: "https://knswindows.com/pvc", hrefLang: "en" },
        { href: "https://knsokna.pl/pvc", hrefLang: "pl" },
        { href: "https://knsfenster.de/pvc", hrefLang: "de" },
        { href: "https://kns-okna.eu/pvc", hrefLang: "cs" },
        { href: "https://knsfinestre.it/pvc", hrefLang: "it" },
        { href: "https://knsfenetres.fr/pvc", hrefLang: "fr" },
        { href: "https://knsokna.eu/pvc", hrefLang: "hu" },
    ]}/>
    <div className="bg-white">
      <div className="mx-auto max-w-7xl px-4 py-2 text-center sm:px-6 lg:px-8">
        <Breadcrumb />
        <Products products={products} translateSlug/>
      </div>
    </div>
  </>);
const getStaticProps: GetStaticProps = async (context) => {
    const locale = context.locale || "PL";
    const LOCALE = locale === "cz" ? "CS" : locale.toUpperCase();
    const { products } = await getAllPvcProductsWithouParent(LOCALE);
    return {
        props: {
            products,
        },
    };
};
export default PvcProducts;

    async function __Next_Translate__getStaticProps__1a19cd2bf27__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/pvc/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a19cd2bf27__ as getStaticProps }
  